import { render, staticRenderFns } from "./TaskTemplateTable.vue?vue&type=template&id=77fee589"
import script from "./TaskTemplateTable.vue?vue&type=script&lang=js"
export * from "./TaskTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplateTable.vue?vue&type=style&index=0&id=77fee589&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FProduct%2FTaskTemplate%2FTaskTemplateTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports